import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Freeform from '~/components/blocks/core/Freeform';

const FreeformBlock = ({ html }) => <Freeform {...{ html }} />;

FreeformBlock.propTypes = {
    html: PropTypes.string.isRequired
};

export default FreeformBlock;

export const fragment = graphql`
    fragment FreeformBlockFragment on WpCoreFreeformBlock {
        html: originalContent
    }
`;

export const exampleData = [
    {
        variant: 'Utilizes the Classic Editor in the Admin',
        props: {
            name: 'core/freeform',
            html: '\n<h2 style="text-align: center;"><del><span style="color: #800000;"><strong><em>Autobell</em></strong></span></del></h2>'
        }
    }
];
